export default "__VITE_ASSET__DNOODd2M__"